import React, { ReactElement, useState } from "react";
import { ThemeProvider } from "styled-components";

import Section from "components/Section";

import { Logo, Container } from "./BusinessAreaLogo.styled";
import BusinessAreaLogoProps from "./BusinessAreaLogoProps";

const BusinessAreaLogo = ({
    identifier,
    anchorName,
    logo,
}: BusinessAreaLogoProps): ReactElement => {
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

    const onLogoLoad = (
        event: React.SyntheticEvent<HTMLImageElement, Event>,
    ) => {
        const img = event.target as HTMLImageElement;

        setDimensions({
            height: img.naturalHeight,
            width: img.naturalWidth,
        });
    };

    const { width, height } = dimensions;

    const getFormat = (): string | undefined => {
        if (!width || !height) {
            return undefined;
        }
        if (width > height) {
            return "landscape";
        }
        if (width < height) {
            return "portrait";
        }
        return "square";
    };

    return (
        <Section
            theme="lightgray"
            alignItems="center"
            key={identifier}
            id={anchorName}
            editPropertyName="Logo"
        >
            <ThemeProvider theme={{ format: getFormat() }}>
                <Container
                    key={identifier || `BusinessAreaLogoContent`}
                    id={identifier}
                >
                    {logo && (
                        <Logo
                            onLoad={onLogoLoad}
                            src={logo.url}
                            alt={logo.alt}
                        />
                    )}
                </Container>
            </ThemeProvider>
        </Section>
    );
};

export default React.memo(BusinessAreaLogo);
